<ion-content class="bg-color marketplace-container">
  <div class="marketplace-content">
    <div class="result-info-container">
      <div class="mob-filter">
        <button (click)="openBottomSheet()">Filters
          <span class="arrow down"></span>
        </button>
      </div>
      <div class="result-content">
        <div class="result-range">
          <span class="result-count">Showing {{total_records == 0 ? 0 : minRecords}}-{{total_records <= 10 ? total_records : maxRecords}} of
            {{total_records}} results for&nbsp;<span class="selected-category-name">"{{currentCategory}}"</span>
          </span>
        </div>
        <div class="sort-by-details">
          <span>
            <button [matMenuTriggerFor]="menu" class="sort-button">Sort by: {{sortSelection}}
              <span class="sort-arrow-icon"></span>
            </button>
            <mat-menu #menu="matMenu" class="sort-menu" xPosition="after" yPosition="below" [overlapTrigger]="false" [offsetY]="5">
              <button mat-menu-item *ngFor="let sort of sortCatalog" value="{{sort.id}}" (click)="sortBySelection(sort)">{{sort.label}}</button>
            </mat-menu>
          </span>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
  
    <div class="filter-catalog-container" *ngIf="catalogDataLoaded">
      <div class="side-content">
        <mat-card class="filter-control-card" *ngIf="filterArray.length !== 0">
          <mat-card-content class="filter-control-content">
            <div class="filter-control-frame">
              <div class="filter-control-header">
                <h4 class="filter-control-title">Filters</h4>
                <span class="filter-control-clear" (click)="clearAll()">Clear All</span>
              </div>
              <div class="filter-control-applied">
                <mat-chip-listbox class="filter-control-list" *ngFor="let filter of filterArray; let i = index">
                  <span *ngIf="i < filterCount">
                    <mat-chip class="filter-control-chip">
                      <span class="filter-control-name">{{filter.name}}</span>
                    
                      <button (click)="clearFilter(filter.name,filter.id,filter,i)" matChipRemove
                        [attr.aria-label]="'remove ' + filter">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip>
                  </span>
                </mat-chip-listbox>
              </div>

              <div *ngIf="filterArray.length > 4" class="filter-control-toggle">
                <button class="filter-control-showmore" (click)="toggleFilterDisplay()">{{(filterCount === 4)?" Show More":"Show
                  Less"}}
                  <span class="arrow" [ngClass]="{ 'down': filterCount === 4, 'up': filterCount !== 4 }"></span>
                </button>
              </div>
            </div>
            <mat-divider *ngIf="filterArray.length !== 0"></mat-divider>

          </mat-card-content>
        </mat-card>

        <mat-card class="filter-catalog-card">
          <mat-card-content class="filter-catalog-content">
            <div class="filter-catalog-frame">
              <!-- BRAND FILTER (DESKTOP) -->
              <div class="filter-catalog-header" *ngIf="brandList.length !== 0">
                <h4 class="filter-catalog-title" style="margin-top: 0px;">BRAND</h4>
                <div 
                  class="filter-catalog-scroll" #brandscroll [class.filter-catalog-show]="brandShow" 
                  [ngClass]="{ 'filter-catalog-lessdata': brandList.length < 8 }">
                  <div class="filter-catalog-list" *ngFor="let catalog of brandList ">
                    <mat-checkbox 
                      class="filter-catalog-checkbox" matInput #brandCheckbox 
                      *ngIf="catalog.name.trim() !== ''" [(ngModel)]="catalog.IsChecked"
                      (change)="brand(catalog.id, catalog, $event)">
                      <span class="filter-catalog-name">{{catalog.name}}</span>
                    </mat-checkbox>
                  </div>
                  <br>
                </div>
                <button class="filter-catalog-showmore" *ngIf="brandList.length > 8" 
                  (click)="brandShow = !brandShow">
                  <span *ngIf="!brandShow"> Show More<i class="arrow down"></i></span>
                  <span *ngIf="brandShow"  (click)="scrollToTop(brandscroll)">Show Less<i class="arrow up"></i></span>
                </button>
              </div>
              <mat-divider></mat-divider>

              <!-- PRODUCT NAME FILTER (DESKTOP) -->
              <div class="filter-catalog-header" *ngIf="productNameList.length !== 0">
                <h4 class="filter-catalog-title">PRODUCT NAME </h4>
                <div 
                  class="filter-catalog-scroll" #productscroll [class.filter-catalog-show]="productShow" 
                  [ngClass]="{ 'filter-catalog-lessdata': productNameList.length < 8 }">
                  <div class="filter-catalog-list " *ngFor="let catalog of productNameList">
                    <mat-checkbox 
                      class="filter-catalog-checkbox" matInput #productCheckbox 
                      *ngIf="catalog.name.trim() !== ''" [(ngModel)]="catalog.IsChecked"
                      (change)="productnames(catalog.name, catalog, $event)">
                      <span class="filter-catalog-name">{{catalog.name}}</span>
                    </mat-checkbox>
                  </div>
                  <br>
                </div>
                <button class="filter-catalog-showmore" *ngIf="productNameList.length > 8" 
                  (click)="loadMoreProductNames()">
                  <span *ngIf="!productShow"> Show More<i class="arrow down"></i></span>
                  <span *ngIf="productShow"  (click)="scrollToTop(productscroll)">Show Less<i class="arrow up"></i></span>
                </button>
              </div>
              <mat-divider></mat-divider>

              <!-- BUSINESS OBJECT FILTER (DESKTOP) -->
              <div class="filter-catalog-header" *ngIf="businessObjList.length !== 0">
                <h4 class="filter-catalog-title"> BUSINESS OBJECT </h4>
                <div 
                  class="filter-catalog-scroll" [class.filter-catalog-show]="objectShow" #businessscroll 
                  [ngClass]="{ 'filter-catalog-lessdata': businessObjList.length < 8 }">
                  <div class="filter-catalog-list" *ngFor="let catalog of businessObjList">
                    <mat-checkbox 
                      class="filter-catalog-checkbox" matInput #businessObjCheckbox 
                      *ngIf="catalog.name.trim() !== ''" [(ngModel)]="catalog.IsChecked" 
                      (change)="businessobj(catalog.name, catalog, $event)">
                      <span class="filter-catalog-name">{{catalog.name}}</span>
                    </mat-checkbox>
                  </div>
                </div>
                <button class="filter-catalog-showmore" *ngIf="businessObjList.length > 8" 
                  (click)="loadMoreBusinessObjects()">
                  <span *ngIf="!objectShow"> Show More<i class="arrow down"></i></span>
                  <span *ngIf="objectShow" (click)="scrollToTop(businessscroll)">Show Less<i class="arrow up"></i></span>
                </button>
              </div>
              <mat-divider></mat-divider>
            
              <!-- METHOD FILTER (DESKTOP) -->
              <div class="filter-catalog-header" *ngIf="methodList.length !== 0">
                <h4 class="filter-catalog-title"> METHOD </h4>
                <div 
                  class="filter-catalog-scroll" 
                  [ngClass]="{ 'filter-catalog-lessdata': methodList.length < 8 }">
                  <div class="filter-catalog-list" *ngFor="let catalog of methodList">
                    <mat-checkbox 
                      class="filter-catalog-checkbox" matInput #methodCheckbox 
                      [(ngModel)]="catalog.IsChecked"
                      (change)="method(catalog.id, catalog, $event)">
                      <span class="filter-catalog-name"> {{catalog.name}}</span>
                    </mat-checkbox>
                  </div>
                  <br>
                </div>
              </div>
              <mat-divider></mat-divider>

              <!-- TYPE FILTER (DESKTOP) -->
              <div class="filter-catalog-header" *ngIf="typeList.length !== 0">
                <h4 class="filter-catalog-title"> Type </h4>
                <div 
                  class="filter-catalog-scroll" 
                  [ngClass]="{ 'filter-catalog-lessdata': typeList.length < 8 }">
                  <div class="filter-catalog-list" *ngFor="let catalog of typeList ">
                    <mat-checkbox 
                      class="filter-catalog-checkbox" matInput #typeCheckbox 
                      [(ngModel)]="catalog.IsChecked"
                      (change)="type(catalog.id, catalog, $event)">
                      <span class="filter-catalog-name">{{catalog.name}}</span>
                    </mat-checkbox>
                  </div>
                  <br>
                </div>
              </div>
              <mat-divider></mat-divider>

              <!-- PRICE FILTER (DESKTOP) -->
              <div class="filter-catalog-header" *ngIf="priceList.length !== 0">
                <h4 class="filter-catalog-title"> PRICE </h4>
                <div 
                  class="filter-catalog-scroll" 
                  [ngClass]="{ 'filter-catalog-lessdata': priceList.length < 8 }">
                  <div class="filter-catalog-list" *ngFor="let catalog of priceList ">
                    <mat-checkbox 
                      class="filter-catalog-checkbox" matInput #priceCheckbox 
                      [(ngModel)]="catalog.IsChecked"
                      (change)="price(catalog.id, catalog, $event)">
                      <span class="filter-catalog-name"> {{catalog.name}}</span>
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="main-content">
        <mat-card class="catalog-info-card" *ngFor="let cat of catalogData">
          <mat-card-header class="catalog-info-header" (click)="catalogDetails(cat.id)">
            <img class="catalog-info-image" [src]="'data:image/jpg;base64,' + cat.image">
            <mat-card-title-group class="catalog-info-titlegroup">
              <mat-card-title class="catalog-info-title">
                <ng-container *ngIf="cat.api_description">
                  <span class="catalog-info-description" (click)="catalogDetails(cat.id)">
                    {{ cat.api_description }}
                  </span>
                </ng-container>
                <ng-container *ngIf="!cat.api_description">
                  <span class="catalog-info-description">No Description</span>
                </ng-container>
              </mat-card-title>
              <mat-card-subtitle class="catalog-info-subtitle">
                <span class="catalog-info-details"> By {{cat.api_brand}} | {{cat.api_product_name}} | {{cat.api_category}}</span>
                <span class="catalog-info-type">Type: {{cat.api_type}}</span>
                <h3 class="catalog-info-busobj"> {{cat.api_business_object}} </h3>
                <span>
                  Method: {{cat.api_method}}
                  &nbsp;&nbsp;
                  Price & Deal: {{cat.api_price}}
                </span>
              </mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
        </mat-card>
        <div class="catalog-noinfo-card" *ngIf="catalogDataLoaded">
          <div *ngIf="!catalogData.length">
            <p class="catalog-noinfo-result">
              Sorry, No Results Found!
            </p>
            <p class="catalog-noinfo-msg">
              Try searching for something else
            </p>
          </div>
        </div>
        <div class="pagination">
          <app-marketplace-pagination *ngIf="catalogDataLoaded" [current]="currentPage" [total]="totalPages"
            (goTo)="onGoTo($event)" (next)="onNext($event)" (previous)="onPrevious($event)">
          </app-marketplace-pagination>
        </div> 
      </div> 
    </div>
  </div>
</ion-content>